import { createTheme } from '@mui/material/styles';

export const COLORS = {
  white: '#FFFFFF',
  black: '#000000',
  blue: 'rgba(33,100,142,1)',
  green: 'rgba(0,117,92,1)',
  orange: 'orange',
  red: 'rgba(175,52,45,1)',
  purple: '#970000',
  appRed: '#7e0000',
  appGrey: '#727272',
  lightGrey: 'lightGrey',
  appBackground: '#5a5c65',
  iconGrey: '#484848',
  menuGrey: '#373a47',
  nBg: '#2c2f3b',
  nPodium: '#3f424c',
};

export const FONTS = {
  // myriadpro: 'Myriad Pro',
  // alegreya: 'Alegreya Sans',
  // garamond: 'EB Garamond',
  // roboto: 'Roboto Condensed',
  // arial: 'Arial',
  // source: 'SourceSerif',
  // montserrat: 'Montserrat',
  CormorantInfant: 'Cormorant Infant',
  CormorantUpright: 'Cormorant Upright',
  Cormorant: 'Cormorant',
  NotoSans: 'Noto Sans',
};

export const FONT_WEIGHT = {
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
};

// export const SIZES = {
//   maxSearchBlockWidth: 440,
// };

const fontFamily: string = ['Arial', 'sans'].join(','); // '"Alegreya Sans"',

export const theme = createTheme({
  palette: {
    primary: { main: COLORS.appRed },
    secondary: { main: COLORS.appGrey },
    // background: {
    //   paper: COLORS.background,
    // },
    // type: 'dark',
  },
  typography: {
    fontFamily,
    // fontWeightRegular: 400,
    // fontWeightMedium: 500,
    // fontWeightBold: 700,
    // h2: {
    //   fontSize: '50px',
    // },
    h3: {
      // verticalAlign: 'middle',
      // alignItems: 'center',
      // textAlign: 'center',
      // fontFamily: FONTS.garamond,
      // fontWeight: FONT_WEIGHT.medium,
      // fontSize: '20px',
      // color: COLORS.textBlack,
      // textTransform: 'uppercase',
    },
    // h1: {
    //   fontSize: '86px',
    //   color: COLORS.white,
    //   verticalAlign: 'middle',
    //   alignItems: 'center',
    //   textAlign: 'center',
    // },
  },
  // overrides: {
  //   MuiCssBaseline: {
  //     '@global': {
  //       '@font-face': [alegreyaSans, ebGaramond],
  //     },
  //   },
  // },
});
